//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
import {
  Box,
  Button,
  Checkbox,
  CheckboxGroup,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Select,
  Stack,
  Text,
} from "@chakra-ui/react";
import Icon from "./ui-elements/Icon";
import { format, isFuture, isToday } from "date-fns";
import Pluralize from "pluralize";
import * as React from "react";
import { SCHEDULE_DATA } from "../utils/data";
import { getWeekDay, isValidObject, scrollToId } from "../utils/functions";
import ReactDatePicker from "./ui-elements/DatePicker";
import { BOOK_LESSONS_ACTION } from "../stores/jobs/utils/request";

const getInitialSchedule = (lessonInfo: any) => {
  let result = {};
  lessonInfo.lessonDays.forEach((day: any) => {
    result = {
      ...result,
      [day]: {
        startTime: lessonInfo.lessonTime,
        hours: lessonInfo.lessonHours,
      },
    };
  });

  return result;
};

type Props = {
  lessonInfo: any;
  tutorResponse: any;
  openModal: any;
  requestSLUG: string;
  assignedSupport: any;
  onSetSchedule: any;
  requestStatus: any;
  bookingStage: any;
  [key: string]: any;
};

const BookLessons = ({
  lessonInfo,
  tutorResponse,
  openModal,
  requestSLUG,
  assignedSupport,
  onSetSchedule = () => {},
  requestStatus,
  bookingStage,
  ...rest
}: Props) => {
  const { daysOfTheWeek, hourlyTimes, hoursOfLesson } = SCHEDULE_DATA;
  const today = new Date().toISOString();
  const todayDate = today.split("T")[0];
  const initialStart = tutorResponse.callFeedback?.startDate;
  const [startDate, setStartDate] = React.useState(initialStart);
  const [lessonDays, setLessonDays] = React.useState(lessonInfo.lessonDays);
  const [weeklySchedule, setWeeklySchedule] = React.useState(
    getInitialSchedule(lessonInfo),
  );
  const [startDayError, setStartDayError] = React.useState(false);
  const [error, setError] = React.useState(false);

  const weeklyLessons = lessonDays.length;
  const startDay = getWeekDay(startDate);
  const emptySchedule = { startTime: "", hours: "" };
  const isStartDateValid =
    startDate && (isToday(startDate) || isFuture(startDate));

  const hoursPerWeek: any = () => {
    const schedule = Object.values(weeklySchedule);
    const hourReducer = (accumulator: any, currentValue: any) => {
      return currentValue.hours
        ? accumulator + parseFloat(currentValue.hours)
        : accumulator;
    };
    return schedule.reduce(hourReducer, 0);
  };

  const hoursBooked =
    lessonInfo.lessonDays.length *
    lessonInfo.lessonDuration *
    lessonInfo.lessonHours;

  //Booking can't be more than twice the duration initially booked
  const allowableWeeks = lessonInfo.lessonDuration * 2;
  const minWeeklyHours = hoursBooked / allowableWeeks;

  const isLessonTooLong = () => {
    const lessonLength = hoursBooked / hoursPerWeek();
    return lessonLength > allowableWeeks;
  };

  const isScheduleValid = (schedule?: any) => {
    if (schedule) {
      if (Object.keys(schedule).length === weeklyLessons) {
        return Object.values(schedule).every(isValidObject as any);
      } else return false;
    } else {
      if (Object.keys(weeklySchedule).length === weeklyLessons) {
        return Object.values(weeklySchedule).every(isValidObject as any);
      } else return false;
    }
  };

  const onScheduleChange = (weekDay, schedule) => {
    let initialSchedule = weeklySchedule?.[weekDay];
    let newSchedule =
      initialSchedule !== null ? { ...initialSchedule, ...schedule } : schedule;
    let newWeeklySchedule = { ...weeklySchedule, [weekDay]: newSchedule };
    setWeeklySchedule(newWeeklySchedule);
    if (isScheduleValid(newWeeklySchedule)) {
      setError(false);
    }
  };

  const handleClick = () => {
    if (isStartDateValid && weeklyLessons > 0) {
      if (lessonDays.includes(startDay)) {
        setStartDayError(false);
        if (isScheduleValid() && !isLessonTooLong()) {
          onSetSchedule({
            startDate,
            startDay,
            hoursBooked,
            weekDays: weeklySchedule,
          });
          openModal(BOOK_LESSONS_ACTION);
        } else setError(true);
      } else {
        setStartDayError(true);
        scrollToId(`${requestSLUG}-schedule`);
      }
    } else setError(true);
  };

  const handleDateChange = (date) => {
    if (date) {
      const ISO_DATE = date.toISOString();
      setStartDate(ISO_DATE.split("T")[0]);
      let newStartDay = getWeekDay(date);
      if (lessonDays.includes(newStartDay)) setStartDayError(false);
    } else setError(true);
  };

  const handleDaysChange = (daysOfLesson) => {
    setLessonDays(daysOfLesson);
    if (daysOfLesson.includes(startDay)) setStartDayError(false);
    let newSchedule = {};
    daysOfLesson.forEach((day) => {
      newSchedule = {
        ...newSchedule,
        [day]: weeklySchedule?.[day] || emptySchedule,
      };
    });
    setWeeklySchedule(newSchedule);
  };

  return (
    <Stack spacing={[5, 6]} px={[5, 6]} {...rest}>
      <Flex
        align="center"
        bg="orange.50"
        justifyContent="center"
        borderRadius="fbRadius"
        borderWidth="xs"
        borderColor="orange.200"
        direction="column"
        p={[5, 6]}
      >
        <Stack align="center" fontWeight="bold">
          <Text fontSize="3xl">🎉</Text>
          <Text fontSize="lg">You have a new booking!</Text>
        </Stack>
      </Flex>

      <Stack spacing={1}>
        <Text fontSize="lg" fontWeight="medium">
          Schedule your lessons
        </Text>
        <Text opacity={0.7}>
          Follow the steps below to book your lessons to help you track lesson
          delivery and to process your payment afterwards. Ensure you have
          concluded on the lesson schedule together with the client.
        </Text>
      </Stack>

      <Stack spacing={[6, 8]}>
        <FormControl
          isInvalid={!isStartDateValid && error}
          width={["100%", "50%"]}
        >
          <FormLabel>1. When will lessons start?</FormLabel>
          <ReactDatePicker
            onChange={(date: any) => handleDateChange(date)}
            minDate={new Date(todayDate)}
            selected={new Date(startDate)}
            placeholder="Select start date"
          />

          <FormErrorMessage>Please enter a valid start date</FormErrorMessage>
          {startDate && !(!isStartDateValid && error) && (
            <Stack mt={2} isInline align="center" color="gray.500">
              <Icon name="notification" />
              <Text fontSize="sm">
                Starts {startDay}, {format(startDate, "MMM Do")}
              </Text>
            </Stack>
          )}
        </FormControl>

        <FormControl
          id={`${requestSLUG}-schedule`}
          isInvalid={weeklyLessons === 0 || startDayError}
        >
          <FormLabel>2. What days will lessons hold?</FormLabel>
          <CheckboxGroup
            defaultValue={lessonInfo.lessonDays}
            onChange={(value) => handleDaysChange(value)}
            value={lessonDays}
          >
            <Stack
              spacing={3}
              d="grid"
              boxSize="lg"
              gridTemplateColumns={["repeat(2, 1fr)", "repeat(4, 1fr)"]}
            >
              {daysOfTheWeek.map((weekday) => (
                <Checkbox
                  isInvalid={weeklyLessons === 0}
                  value={weekday.longDay}
                  key={weekday.longDay}
                >
                  <Text fontSize="md">{weekday.longDay}s</Text>
                </Checkbox>
              ))}
            </Stack>
          </CheckboxGroup>
          <FormErrorMessage>
            {weeklyLessons === 0
              ? "Please select days for lessons"
              : `The start day, ${startDay}, must be selected`}
          </FormErrorMessage>
          {weeklyLessons > 0 && !startDayError && (
            <Stack mt={2} isInline align="center" color="gray.500">
              <Icon name="calendar-outline" />
              <Text fontSize="sm">
                Teaching {Pluralize("lesson", weeklyLessons, true)} per week
              </Text>
            </Stack>
          )}
        </FormControl>

        <Stack spacing={3}>
          <Text fontWeight="medium">3. Select lesson times and duration</Text>
          <FormControl isInvalid={error && !isScheduleValid()}>
            <Stack spacing={3}>
              {lessonDays.map((lessonDay) => (
                <LessonWeekDay
                  key={lessonDay}
                  lessonDay={lessonDay}
                  error={error}
                  hourlyTimes={hourlyTimes}
                  hoursOfLesson={hoursOfLesson}
                  schedule={weeklySchedule[lessonDay] || emptySchedule}
                  onChange={(schedule) => onScheduleChange(lessonDay, schedule)}
                />
              ))}
            </Stack>
            {!(error && !isScheduleValid()) && (
              <Stack mt={2} isInline align="center" color="gray.500">
                <Icon name="time" />
                {hoursPerWeek() > 0 ? (
                  <Text fontSize="sm">
                    {Pluralize("lesson hour", hoursPerWeek(), true)} per week
                  </Text>
                ) : (
                  <Text fontSize="sm">
                    Minimum: {Pluralize("hour", minWeeklyHours, true)} per week
                  </Text>
                )}
              </Stack>
            )}
            <FormErrorMessage>
              Please select lesson times and duration above
            </FormErrorMessage>
          </FormControl>
        </Stack>
      </Stack>

      {isScheduleValid() && isLessonTooLong() && (
        <Stack isInline align="center" color="red.500" fontSize="sm">
          <Icon name="error" />
          <Text>
            You must teach at least {Pluralize("hour", minWeeklyHours, true)}{" "}
            per week
          </Text>
        </Stack>
      )}

      <Box mt={5} width={["100%", "40%"]}>
        <Button colorScheme="blue" onClick={handleClick} isFullWidth size="lg">
          Schedule lessons
        </Button>
      </Box>
    </Stack>
  );
};

const LessonWeekDay = ({
  hourlyTimes = [],
  lessonDay,
  error,
  hoursOfLesson = [],
  schedule,
  onChange = () => {},
  ...rest
}: {
  hourlyTimes: Array<any>;
  lessonDay: string;
  error: any;
  hoursOfLesson?: Array<any>;
  schedule: any;
  onChange: any;
  [key: string]: any;
}) => {
  const handleChange = (key: any, value: any) => {
    let newValue = { ...schedule, [key]: value };
    onChange(newValue);
  };

  return (
    <Flex
      align="center"
      bg="neutral.200"
      direction={["column", "row"]}
      rounded="fbRadius"
      px={5}
      py={3}
      {...rest}
    >
      <Text mb={[3, 0]} fontWeight="medium" fontSize="md" flex={1}>
        {lessonDay}s
      </Text>

      <Stack width={["100%", "60%"]} isInline align="center" spacing={[3, 5]}>
        <Select
          bg="white"
          iconSize="1rem"
          zIndex={1}
          isInvalid={error && !schedule.startTime}
          defaultValue={schedule.startTime}
          placeholder="Start time"
          onChange={(e) => handleChange("startTime", e.target.value)}
          rounded="md"
        >
          {hourlyTimes.map((time) => (
            <option key={time} value={time}>
              {time}
            </option>
          ))}
        </Select>

        <Select
          bg="white"
          iconSize="1rem"
          zIndex={1}
          isInvalid={error && !schedule.hours}
          defaultValue={schedule.hours}
          onChange={(e) => handleChange("hours", e.target.value)}
          placeholder="How long?"
          rounded="md"
        >
          {hoursOfLesson.map(({ label, value }) => (
            <option key={value} value={value}>
              {label}
            </option>
          ))}
        </Select>
      </Stack>
    </Flex>
  );
};

export default BookLessons;
